import MarqueeLib from "react-fast-marquee";

const items = [
  "LEGACY APPLICATIONS",
  "MODERN POSSIBILITIES",
  "FROM COBOL TO CLAUDE",
  "EVOLUTION, NOT REVOLUTION",
];

const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="border-y hairline bg-ink py-6 overflow-hidden relative z-10"
  >
    <MarqueeLib speed={28} gradient={false} pauseOnHover>
      {items.concat(items).map((t, i) => (
        <span key={i} className="flex items-center">
          <span className="font-serif text-xl md:text-2xl italic text-slate-300 mx-10 whitespace-nowrap">
            {t}
          </span>
          <span className="font-mono-tech text-amber-500/60 text-sm">//</span>
        </span>
      ))}
    </MarqueeLib>
  </div>
);

export default Marquee;
